/**
 * Feature flags mirroring the legacy app's Web.config-driven `Settings.*` values
 * (HasBusServices, HasKurumsal, IsVirtualPosEnabled, HasTourIframe, ...).
 *
 * There is no API source — `Config/GetAppConfig` was never built. Flags are hardcoded
 * here; override at build time by editing this file (or wire an env var per flag if a
 * per-deploy toggle is ever needed). In-scope modules default enabled; the Turlar
 * iframe defaults disabled (no embed URLs configured).
 */
export type FeatureFlagName =
  | 'HasBusServices'
  | 'HasKurumsal'
  | 'IsVirtualPosEnabled'
  | 'HasTourIframe'
  | 'HasCmsB2C'
  | 'HasLogs'
  | 'HasInsurance';

const FEATURE_FLAGS: Record<FeatureFlagName, boolean> = {
  HasBusServices: true,
  HasKurumsal: true,
  IsVirtualPosEnabled: true,
  HasTourIframe: false,
  HasCmsB2C: true,
  HasLogs: true,
  // Legacy MVC panel had no InsuranceController — the Tamamlıyo quote→offer→policy
  // vertical is a brand-new surface. Kept off by default; flip when it's live-verified.
  HasInsurance: true,
};

/**
 * Plain function, not a React hook, despite reading like config state — it's a
 * synchronous lookup. Named without a `use` prefix on purpose so it can be called from
 * non-component contexts (e.g. a menu item's `isVisible` predicate) without tripping
 * the react-hooks/rules-of-hooks lint rule.
 */
export function isFeatureEnabled(name: FeatureFlagName): boolean {
  return FEATURE_FLAGS[name];
}
